export const email_address = 'caresmart@gmail.com';
export const phone_no = '+91 1800******';
export const address = '65, Gaytri puram, Kursi Road, Lucknow- 226022';
export const company_name = 'Caresmart Health Solution';

